// Periodicidade do empréstimo → intervalo entre prestações em meses.
// O label é guardado em `periodicity` e o intervalo em `frequencyMonths` (§1.1).
export interface PeriodicityOption {
  label: string;
  frequencyMonths: number;
}

export const PERIODICITY_OPTIONS: PeriodicityOption[] = [
  { label: "Mensal", frequencyMonths: 1 },
  { label: "Trimestral", frequencyMonths: 3 },
  { label: "Semestral", frequencyMonths: 6 },
  { label: "Anual", frequencyMonths: 12 },
];

/** Deriva o intervalo em meses a partir do label da periodicidade (null se não-standard). */
export function frequencyMonthsForLabel(label: string): number | null {
  return PERIODICITY_OPTIONS.find((option) => option.label === label)
    ?.frequencyMonths ?? null;
}

/** Deriva o label da periodicidade a partir do intervalo em meses (para carregar em edição). */
export function labelForFrequencyMonths(
  frequencyMonths: number | null | undefined,
): string | null {
  if (frequencyMonths === null || frequencyMonths === undefined) return null;
  return (
    PERIODICITY_OPTIONS.find(
      (option) => option.frequencyMonths === frequencyMonths,
    )?.label ?? null
  );
}
